<template>
    <div>

        <impersonate />

        <router-view />

        <!-- NEW popup logic -->
        <modals-container />

    </div>
</template>

<script>
export default {
    name: "page",

    components: {
        impersonate: () => import(/* webpackChunkName: "elements" */ "@/components/general/impersonate")
    }
};
</script>
